<template>
  <div class="calc-nav-desktop">
    <div
      class="calculator-nav__inner"
    >
      <slot name="content">
        <a
          class="calculator__button calculator__button_back-step"
          @click.prevent="$emit('step-back')"
        >
        <span>
          {{ $t('calc.btn.nazad') }}
        </span>
          <svg
            class="arrow-icon"
            width="24px"
            height="24px"
          >
            <use xlink:href="#arrow-down" />
          </svg>
        </a>
        <CalcCommentError
          v-if="errorText"
          class="calc-nav-desktop__error"
        >
          {{ errorText }}
        </CalcCommentError>
        <a
          v-if="!hideBtnNext"
          class="calculator__button calculator__button_red calculator__button_next-step"
          :class="{'calculator__button_loading': isLoading}"
          @click.prevent="$emit('stepValidation')"
        >
          <slot name="btnNext">
            <svg
              class="arrow-icon"
              width="24px"
              height="24px"
            >
              <use xlink:href="#arrow-down" />
            </svg>
            {{ $t('calc.btn.dalee') }}
          </slot>
        </a>
      </slot>
    </div>
  </div>
</template>

<script>
import CalcCommentError from './CalcCommentError.vue';

export default {
  name: 'CalcNavDesktop',
  components: { CalcCommentError },
  props: ['isLoading', 'errorText', 'hideBtnNext'],
};
</script>

<style lang="scss" scoped>
.calculator__button_next-step {
  padding: 8px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  .arrow-icon {
    margin: 0 0 0 8px;
  }
}
.calc-nav-desktop__error {
  padding-top: 7px;
  padding-bottom: 7px;
  min-height: 40px;
  width: auto;
  margin-left: auto;
  margin-right: 24px;
}
</style>
